import beauty from "./beauty.jpg";
import bookstore from "./bookstore.jpg";
import gamingstore from "./gaming-store.jpg";
import kitchen_favorite from "./kitchen-favorite.jpg";
import toys from "./toys.jpg";
import imgOne from "../assets/row-one-and-two/img-1.jpg";
import img_1 from "../assets/row-one-and-two/img-1-1.jpg";
import img_2 from "../assets/row-one-and-two/img-1-2.jpg";
import img_3 from "../assets/row-one-and-two/img-1-3.jpg";
import img_4 from "../assets/row-one-and-two/img-2-1.jpg";
import img_5 from "../assets/row-one-and-two/img-2-2.jpg";
import img_6 from "../assets/row-one-and-two/img-2-3.jpg";
import img_7 from "../assets/row-one-and-two/img-2-4.jpg";
import img_8 from "../assets/row-one-and-two/img-3-1.jpg";
import img_9 from "../assets/row-one-and-two/img-3-2.jpg";
import img_10 from "../assets/row-one-and-two/img-3-3.jpg";
import img_11 from "../assets/row-one-and-two/img-3-4.jpg";
import img_12 from "../assets/row-one-and-two/img-4-1.jpg";
import img_13 from "../assets/row-one-and-two/img-4-2.jpg";
import img_14 from "../assets/row-one-and-two/img-4-3.jpg";
import img_15 from "../assets/row-one-and-two/img-4-4.jpg";
import img_16 from "../assets/row-one-and-two/img2-1-1.jpg";
import img_18 from "../assets/row-one-and-two/img2-1-3.jpg";
import img_17 from "../assets/row-one-and-two/img2-1-2.jpg";
import img_19 from "../assets/row-one-and-two/img2-1-4.jpg";
import img_20 from "../assets/row-one-and-two/img2-2-1.jpg";
import img_21 from "../assets/row-one-and-two/img2-2-2.jpg";
import img_22 from "../assets/row-one-and-two/img2-2-3.jpg";
import img_23 from "../assets/row-one-and-two/img2-2-4.jpg";
import img_24 from "../assets/row-one-and-two/img2-3.jpg";
import img_25 from "../assets/row-one-and-two/img2-4.jpg";
import img_26 from "../assets/top-seller-books/img-1.jpg";
import img_27 from "../assets/top-seller-books/img-2.jpg";
import img_28 from "../assets/top-seller-books/img-3.jpg";
import img_29 from "../assets/top-seller-books/img-4.jpg";
import img_30 from "../assets/top-seller-books/img-5.jpg";
import img_31 from "../assets/top-seller-books/img-6.jpg";
import img_32 from "../assets/top-seller-books/img-7.jpg";
import img_33 from "../assets/top-seller-books/img-8.jpg";
import img_34 from "../assets/top-seller-books/img-9.jpg";
import img_35 from "../assets/top-seller-books/img-10.jpg";
import img_37 from "../assets/top-seller-books/img-12.jpg";
import img_38 from "../assets/top-seller-books/img-13.jpg";
import img_39 from "../assets/top-seller-books/img-14.jpg";
import img_40 from "../assets/top-seller-books/img-15.jpg";
import img_41 from "../assets/top-seller-books/img-16.jpg";
import img_42 from "../assets/top-seller-books/img-17.jpg";
// import img_43 from '../assets/top-seller-books/img-18.jpg'
import img_44 from "../assets/top-seller-books/img-19.jpg";
import img_45 from "../assets/top-seller-books/img-20.jpg";
import img_46 from "../assets/between-books/img-1-1.jpg";
import img_47 from "../assets/between-books/img-1-2.jpg";
import img_48 from "../assets/between-books/img-1-3.jpg";
import img_49 from "../assets/between-books/img-1-4.jpg";
import img_50 from "../assets/between-books/img-2-1.jpg";
import img_51 from "../assets/between-books/img-2-2.jpg";
import img_52 from "../assets/between-books/img-2-3.jpg";
import img_53 from "../assets/between-books/img-2-4.jpg";
import img_54 from "../assets/between-books/img-3-1.jpg";
import img_55 from "../assets/between-books/img-3-2.jpg";
import img_56 from "../assets/between-books/img-3-3.jpg";
import img_57 from "../assets/between-books/img-3-4.jpg";
import img_58 from "../assets/between-books/img-4-1.jpg";
import img_59 from "../assets/between-books/img-4-2.jpg";
import img_60 from "../assets/between-books/img-4-3.jpg";
import img_61 from "../assets/between-books/img-4-4.jpg";
import img_62 from "../assets/best-seller-books/img-1.jpg";
import img_63 from "../assets/best-seller-books/img-2.jpg";
import img_64 from "../assets/best-seller-books/img-3.jpg";
import img_65 from "../assets/best-seller-books/img-4.jpg";
import img_66 from "../assets/best-seller-books/img-5.jpg";
import img_67 from "../assets/best-seller-books/img-6.jpg";
import img_68 from "../assets/best-seller-books/img-7.jpg";
import img_69 from "../assets/best-seller-books/img-8.jpg";
import img_70 from "../assets/best-seller-books/img-9.jpg";
import img_71 from "../assets/best-seller-books/img-10.jpg";
import img_72 from "../assets/best-seller-books/img-11.jpg";
import img_73 from "../assets/best-seller-books/img-12.jpg";
import img_74 from "../assets/best-seller-books/img-13.jpg";
import img_75 from "../assets/best-seller-books/img-14.jpg";
import img_76 from "../assets/best-seller-books/img-15.jpg";
import img_77 from "../assets/best-seller-books/img-16.jpg";
import img_78 from "../assets/best-seller-books/img-17.jpg";
import img_79 from "../assets/best-seller-books/img-18.jpg";
import img_80 from "../assets/best-seller-books/img-19.jpg";
import img_81 from "../assets/best-seller-books/img-20.jpg";
import img_82 from "../assets/rows-after-books/img-1-1.jpg";
import img_83 from "../assets/rows-after-books/img-1-2.jpg";
import img_84 from "../assets/rows-after-books/img-1-3.jpg";
import img_85 from "../assets/rows-after-books/img-1-4.jpg";
import img_86 from "../assets/rows-after-books/img-2-1.jpg";
import img_87 from "../assets/rows-after-books/img-2-2.jpg";
import img_88 from "../assets/rows-after-books/img-2-3.jpg";
import img_89 from "../assets/rows-after-books/img-2-4.jpg";
import img_90 from "../assets/rows-after-books/img-3-1.jpg";
import img_91 from "../assets/rows-after-books/img-3-2.jpg";
import img_92 from "../assets/rows-after-books/img-3-3.jpg";
import img_93 from "../assets/rows-after-books/img-3-4.jpg";
import img_94 from "../assets/rows-after-books/img-4-1.jpg";
import img_95 from "../assets/rows-after-books/img-4-2.jpg";
import img_96 from "../assets/rows-after-books/img-4-3.jpg";
import img_97 from "../assets/rows-after-books/img-4-4.jpg";
import img_98 from "../assets/rows-after-books/img2-1-1.jpg";
import img_99 from "../assets/rows-after-books/img2-1-2.jpg";
import img_100 from "../assets/rows-after-books/img2-1-3.jpg";
import img_101 from "../assets/rows-after-books/img2-1-4.jpg";
import img_102 from "../assets/rows-after-books/img2-2-1.jpg";
import img_103 from "../assets/rows-after-books/img2-2-2.jpg";
import img_104 from "../assets/rows-after-books/img2-2-3.jpg";
import img_105 from "../assets/rows-after-books/img2-2-4.jpg";
import img_106 from "../assets/rows-after-books/img2-3-1.jpg";
import img_107 from "../assets/rows-after-books/img2-3-2.jpg";
import img_108 from "../assets/rows-after-books/img2-3-3.jpg";
import img_109 from "../assets/rows-after-books/img2-3-4.jpg";
import img_110 from "../assets/rows-after-books/im2-4.jpg";

export const products = [
  {
    _id: 1,
    name: "Cooker",
    image: imgOne,
    price: "$62.99",
    description:
      "Instant Pot Duo 7-in-1 Mini Electric Pressure Cooker, Slow Rice Cooker, Steamer, Sauté, Yogurt Maker, Warmer & Sterilizer, Includes Free App with over 1900 Recipes, Stainless Steel, 3 Quart",
    contains_gift: true,
  },
  {
    _id: 2,
    name: "Coffee",
    image: img_1,
    price: "$42.77",
    description:
      "Cuisinart Coffee Maker, 14-Cup Glass Carafe, Fully Automatic for Brew Strength Control & 1-4 Cup Setting, Stainless Steel, DCC-3200P1",
    contains_gift: false,
  },
  {
    _id: 3,
    name: "Pots and Pans",
    image: img_2,
    price: "$74.46",
    description:
      "T-fal Signature Nonstick Cookware Set 12 Piece, Oven Broiler Safe 350F, Pots and Pans, Kitchen Cooking Set w/ Fry Pans, Saucepans, Saute Pan, Dutch Oven, Griddle, Kitchen, Home, Dishwasher Safe, Black",
    contains_gift: true,
  },
  {
    _id: 4,
    name: "Kettle",
    image: img_3,
    price: "$11.77",
    description:
      "Tea Kettle for Stove Top - Stainless steel Teapot,2 Quart Camping Kettle, Efficient Heating, Audible Whistle, Safe Handle - Hot Water kettle & Tea Pot Stovetop (Silver)",
    contains_gift: true,
  },
  {
    _id: 5,
    name: "Cleaning tool",
    image: img_4,
    price: "$11.77",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsa in hic itaque praesentium sunt eos aliquid quibusdam omnis. Soluta amet consectetur ipsam blanditiis? Impedit asperiores minus facere nobis, tempore excepturi!",
    contains_gift: false,
  },
  {
    _id: 6,
    name: "Home Storage",
    image: img_5,
    price: "$11.77",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsa in hic itaque praesentium sunt eos aliquid quibusdam omnis. Soluta amet consectetur ipsam blanditiis? Impedit asperiores minus facere nobis, tempore excepturi!",
    contains_gift: false,
  },
  {
    _id: 7,
    name: "Home Decore",
    image: img_6,
    price: "$11.77",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsa in hic itaque praesentium sunt eos aliquid quibusdam omnis. Soluta amet consectetur ipsam blanditiis? Impedit asperiores minus facere nobis, tempore excepturi!",
    contains_gift: false,
  },
  {
    _id: 8,
    name: "Bedding",
    image: img_7,
    price: "$11.77",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsa in hic itaque praesentium sunt eos aliquid quibusdam omnis. Soluta amet consectetur ipsam blanditiis? Impedit asperiores minus facere nobis, tempore excepturi!",
    contains_gift: true,
  },
  {
    _id: 9,
    name: "Headset",
    image: img_8,
    price: "$11.77",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsa in hic itaque praesentium sunt eos aliquid quibusdam omnis. Soluta amet consectetur ipsam blanditiis? Impedit asperiores minus facere nobis, tempore excepturi!",
    contains_gift: true,
  },
  {
    _id: 10,
    name: "Keyboard",
    image: img_9,
    price: "$29.99",
    description:
      "Fusce vestibulum libero ut nibh pulvinar, a fringilla ligula pretium. Maecenas nec massa orci. Aenean suscipit feugiat fermentum. Donec a metus vel nisl ultricies pharetra.",
    contains_gift: false,
  },
  {
    _id: 11,
    name: "Monitor",
    image: img_10,
    price: "$179.99",
    description:
      "Curabitur pharetra metus a libero convallis, a aliquam lectus dignissim. Suspendisse finibus justo eget urna lacinia, ut pulvinar risus dapibus. Integer nec dolor eget augue gravida.",
    contains_gift: true,
  },
  {
    _id: 12,
    name: "Mouse",
    image: img_11,
    price: "$19.99",
    description:
      "Praesent fringilla augue sit amet dolor faucibus, sed placerat velit varius. Duis vel nulla consectetur, vehicula libero vitae, tincidunt felis. Cras in sapien vehicula, sollicitudin mi a.",
    contains_gift: true,
  },
  {
    _id: 13,
    name: "Printer",
    image: img_12,
    price: "$129.99",
    description:
      "Nam ut magna quis dui laoreet facilisis. Quisque sed libero consequat, convallis turpis a, pharetra nisi. Mauris lacinia euismod eros in aliquam. In vel varius lorem.",
    contains_gift: false,
  },
  {
    _id: 14,
    name: "External Hard Drive",
    image: img_13,
    price: "$89.99",
    description:
      "Quisque maximus justo vel tellus sollicitudin, ut eleifend metus aliquet. Proin at felis non ligula congue mollis. Cras malesuada orci id quam tristique, in dignissim arcu ultricies.",
    contains_gift: true,
  },
  {
    _id: 15,
    name: "Router",
    image: img_14,
    price: "$69.99",
    description:
      "Sed cursus lectus sit amet diam convallis laoreet. Suspendisse gravida convallis augue, vel tempor nibh posuere vitae. Nam vel libero pharetra, consequat mauris id, viverra leo.",
    contains_gift: false,
  },
  {
    _id: 16,
    name: "Projector",
    image: img_15,
    price: "$249.99",
    description:
      "Suspendisse euismod, est id egestas laoreet, turpis turpis viverra nisi, ut convallis metus libero nec urna. Duis varius massa quis diam volutpat, id vulputate erat interdum.",
    contains_gift: true,
  },
  {
    _id: 17,
    name: "Smart Thermostat",
    image: img_16,
    price: "$119.99",
    description:
      "Vivamus finibus arcu nec felis tincidunt sollicitudin. Nam tincidunt sem non arcu dictum, vel consectetur sapien posuere. Duis nec risus in eros tristique gravida sit amet in sapien.",
    contains_gift: true,
  },
  {
    _id: 18,
    name: "Vacuum Cleaner",
    image: img_17,
    price: "$199.99",
    description:
      "Aliquam erat volutpat. Suspendisse potenti. Ut dignissim tellus sit amet enim porttitor, eget accumsan odio faucibus. Pellentesque dapibus, turpis ac euismod tincidunt, libero urna.",
    contains_gift: false,
  },
  {
    _id: 19,
    name: "Electric Toothbrush",
    image: img_18,
    price: "$49.99",
    description:
      "Proin ac viverra lorem, id efficitur nulla. Nunc posuere diam nec risus congue, a porttitor ligula vulputate. Ut sodales lacus vitae erat pellentesque, non pharetra sapien suscipit.",
    contains_gift: true,
  },
  {
    _id: 20,
    name: "Hair Dryer",
    image: img_19,
    price: "$39.99",
    description:
      "Ut vulputate libero sit amet risus vulputate, a suscipit orci condimentum. Cras interdum turpis ac enim lacinia, vel tincidunt ipsum lobortis. Vivamus sed tincidunt odio.",
    contains_gift: true,
  },
  {
    _id: 21,
    name: "Blender",
    image: img_20,
    price: "$59.99",
    description:
      "Nulla facilisi. Integer ac libero a risus convallis iaculis. Nulla sit amet sem sed purus malesuada cursus. In hac habitasse platea dictumst. Donec ullamcorper dui non lacus.",
    contains_gift: false,
  },
  {
    _id: 22,
    name: "Iron",
    image: img_21,
    price: "$25.99",
    description:
      "Phasellus in urna et nisi varius volutpat. Cras euismod, lorem et interdum dignissim, lectus purus rutrum sapien, non sollicitudin est ligula eget enim. Aliquam tempor massa.",
    contains_gift: false,
  },
  {
    _id: 23,
    name: "Toaster Oven",
    image: img_22,
    price: "$69.99",
    description:
      "Suspendisse ut facilisis sapien, sed facilisis libero. In tristique erat sed nunc tempor, ac varius nisl scelerisque. Vivamus pharetra quam non ultricies fermentum. Vestibulum non ligula in.",
    contains_gift: false,
  },
  {
    _id: 24,
    name: "Air Purifier",
    image: img_23,
    price: "$99.99",
    description:
      "Curabitur luctus libero ac nibh vehicula, a suscipit ipsum iaculis. Nam a arcu tempor, ultricies lorem ac, laoreet est. In sed justo vitae nisi rhoncus porta. Sed vitae libero non arcu.",
    contains_gift: true,
  },
  {
    _id: 25,
    name: "Electric Shaver",
    image: img_24,
    price: "$39.99",
    description:
      "Aliquam ut lorem nec velit pharetra dignissim. Suspendisse potenti. Nam vehicula augue nec orci lacinia, nec suscipit libero gravida. Fusce vel ex id est luctus accumsan.",
    contains_gift: true,
  },
  {
    _id: 26,
    name: "Slow Cooker",
    image: img_25,
    price: "$49.99",
    description:
      "Sed at nunc sed arcu varius efficitur sed eget ipsum. Sed lacinia lectus nec ante luctus, nec sagittis purus vehicula. Vestibulum posuere quam id quam vehicula tincidunt.",
    contains_gift: false,
  },
  {
    _id: 27,
    name: "Coffee Maker",
    image: img_26,
    price: "$89.99",
    description:
      "Nam eget magna ac arcu dictum efficitur ut id sem. Ut vitae eros vitae nisi tristique tincidunt. Maecenas id urna eget lectus gravida ultricies. Vestibulum ac mauris euismod.",
    contains_gift: true,
  },
  {
    _id: 28,
    name: "Dehumidifier",
    image: img_27,
    price: "$199.99",
    description:
      "Integer faucibus orci non urna efficitur tincidunt. Fusce tristique lectus turpis, vitae tincidunt erat lobortis a. Curabitur et justo pharetra, ullamcorper dolor vitae.",
    contains_gift: false,
  },
  {
    _id: 29,
    name: "Juicer",
    image: img_28,
    price: "$69.99",
    description:
      "Nunc quis turpis id ligula vestibulum blandit. Nulla pharetra velit magna, sit amet iaculis neque fringilla sit amet. Nulla posuere eros id mi pharetra consectetur in tempor arcu.",
    contains_gift: false,
  },
  {
    _id: 30,
    name: "Rice Cooker",
    image: img_29,
    price: "$59.99",
    description:
      "Duis condimentum orci et risus vehicula, ac dapibus lorem elementum. Mauris viverra lorem magna, a tincidunt purus dictum eget. Sed euismod, velit ac tempus tincidunt.",
    contains_gift: true,
  },
  {
    _id: 31,
    name: "Rice Cooker",
    image: img_30,
    price: "$59.99",
    description:
      "Duis condimentum orci et risus vehicula, ac dapibus lorem elementum. Mauris viverra lorem magna, a tincidunt purus dictum eget. Sed euismod, velit ac tempus tincidunt.",
    contains_gift: true,
  },
  {
    _id: 32,
    name: "Rice Cooker",
    image: img_31,
    price: "$59.99",
    description:
      "Duis condimentum orci et risus vehicula, ac dapibus lorem elementum. Mauris viverra lorem magna, a tincidunt purus dictum eget. Sed euismod, velit ac tempus tincidunt.",
    contains_gift: true,
  },
  {
    _id: 33,
    name: "Rice Cooker",
    image: img_32,
    price: "$59.99",
    description:
      "Duis condimentum orci et risus vehicula, ac dapibus lorem elementum. Mauris viverra lorem magna, a tincidunt purus dictum eget. Sed euismod, velit ac tempus tincidunt.",
    contains_gift: true,
  },
  {
    _id: 34,
    name: "Rice Cooker",
    image: img_33,
    price: "$59.99",
    description:
      "Duis condimentum orci et risus vehicula, ac dapibus lorem elementum. Mauris viverra lorem magna, a tincidunt purus dictum eget. Sed euismod, velit ac tempus tincidunt.",
    contains_gift: true,
  },
  {
    _id: 35,
    name: "Rice Cooker",
    image: img_34,
    price: "$59.99",
    description:
      "Duis condimentum orci et risus vehicula, ac dapibus lorem elementum. Mauris viverra lorem magna, a tincidunt purus dictum eget. Sed euismod, velit ac tempus tincidunt.",
    contains_gift: true,
  },
  {
    _id: 36,
    name: "Rice Cooker",
    image: img_35,
    price: "$59.99",
    description:
      "Duis condimentum orci et risus vehicula, ac dapibus lorem elementum. Mauris viverra lorem magna, a tincidunt purus dictum eget. Sed euismod, velit ac tempus tincidunt.",
    contains_gift: true,
  },
  // {
  //     _id:37,
  //     name:'Rice Cooker',
  //     image: img_36,
  //     price:'$59.99',
  //     description:'Duis condimentum orci et risus vehicula, ac dapibus lorem elementum. Mauris viverra lorem magna, a tincidunt purus dictum eget. Sed euismod, velit ac tempus tincidunt.',
  //     contains_gift:true
  // },
  {
    _id: 38,
    name: "Rice Cooker",
    image: img_37,
    price: "$59.99",
    description:
      "Duis condimentum orci et risus vehicula, ac dapibus lorem elementum. Mauris viverra lorem magna, a tincidunt purus dictum eget. Sed euismod, velit ac tempus tincidunt.",
    contains_gift: true,
  },
  {
    _id: 39,
    name: "Rice Cooker",
    image: img_38,
    price: "$59.99",
    description:
      "Duis condimentum orci et risus vehicula, ac dapibus lorem elementum. Mauris viverra lorem magna, a tincidunt purus dictum eget. Sed euismod, velit ac tempus tincidunt.",
    contains_gift: true,
  },
  {
    _id: 40,
    name: "Rice Cooker",
    image: img_39,
    price: "$59.99",
    description:
      "Duis condimentum orci et risus vehicula, ac dapibus lorem elementum. Mauris viverra lorem magna, a tincidunt purus dictum eget. Sed euismod, velit ac tempus tincidunt.",
    contains_gift: true,
  },
  {
    _id: 41,
    name: "Dehumidifier",
    image: img_40,
    price: "$199.99",
    description:
      "Integer faucibus orci non urna efficitur tincidunt. Fusce tristique lectus turpis, vitae tincidunt erat lobortis a. Curabitur et justo pharetra, ullamcorper dolor vitae.",
    contains_gift: false,
  },
  {
    _id: 42,
    name: "Dehumidifier",
    image: img_41,
    price: "$199.99",
    description:
      "Integer faucibus orci non urna efficitur tincidunt. Fusce tristique lectus turpis, vitae tincidunt erat lobortis a. Curabitur et justo pharetra, ullamcorper dolor vitae.",
    contains_gift: false,
  },
  {
    _id: 43,
    name: "Dehumidifier",
    image: img_42,
    price: "$199.99",
    description:
      "Integer faucibus orci non urna efficitur tincidunt. Fusce tristique lectus turpis, vitae tincidunt erat lobortis a. Curabitur et justo pharetra, ullamcorper dolor vitae.",
    contains_gift: false,
  },
  // {
  //     _id:44,
  //     name:'Dehumidifier',
  //     image: img_43,
  //     price:'$199.99',
  //     description:'Integer faucibus orci non urna efficitur tincidunt. Fusce tristique lectus turpis, vitae tincidunt erat lobortis a. Curabitur et justo pharetra, ullamcorper dolor vitae.',
  //     contains_gift:false
  // },
  {
    _id: 45,
    name: "Dehumidifier",
    image: img_44,
    price: "$199.99",
    description:
      "Integer faucibus orci non urna efficitur tincidunt. Fusce tristique lectus turpis, vitae tincidunt erat lobortis a. Curabitur et justo pharetra, ullamcorper dolor vitae.",
    contains_gift: false,
  },
  {
    _id: 46,
    name: "Dehumidifier",
    image: img_45,
    price: "$199.99",
    description:
      "Integer faucibus orci non urna efficitur tincidunt. Fusce tristique lectus turpis, vitae tincidunt erat lobortis a. Curabitur et justo pharetra, ullamcorper dolor vitae.",
    contains_gift: false,
  },
  {
    _id: 47,
    name: "Dehumidifier",
    image: img_46,
    price: "$199.99",
    description:
      "Integer faucibus orci non urna efficitur tincidunt. Fusce tristique lectus turpis, vitae tincidunt erat lobortis a. Curabitur et justo pharetra, ullamcorper dolor vitae.",
    contains_gift: false,
  },
  {
    _id: 48,
    name: "Dehumidifier",
    image: img_47,
    price: "$199.99",
    description:
      "Integer faucibus orci non urna efficitur tincidunt. Fusce tristique lectus turpis, vitae tincidunt erat lobortis a. Curabitur et justo pharetra, ullamcorper dolor vitae.",
    contains_gift: false,
  },
  {
    _id: 49,
    name: "Dehumidifier",
    image: img_48,
    price: "$199.99",
    description:
      "Integer faucibus orci non urna efficitur tincidunt. Fusce tristique lectus turpis, vitae tincidunt erat lobortis a. Curabitur et justo pharetra, ullamcorper dolor vitae.",
    contains_gift: false,
  },
  {
    _id: 50,
    name: "Dehumidifier",
    image: img_49,
    price: "$199.99",
    description:
      "Integer faucibus orci non urna efficitur tincidunt. Fusce tristique lectus turpis, vitae tincidunt erat lobortis a. Curabitur et justo pharetra, ullamcorper dolor vitae.",
    contains_gift: false,
  },
  {
    _id: 51,
    name: "Dehumidifier",
    image: img_50,
    price: "$199.99",
    description:
      "Integer faucibus orci non urna efficitur tincidunt. Fusce tristique lectus turpis, vitae tincidunt erat lobortis a. Curabitur et justo pharetra, ullamcorper dolor vitae.",
    contains_gift: false,
  },
  {
    _id: 52,
    name: "Dehumidifier",
    image: img_51,
    price: "$199.99",
    description:
      "Integer faucibus orci non urna efficitur tincidunt. Fusce tristique lectus turpis, vitae tincidunt erat lobortis a. Curabitur et justo pharetra, ullamcorper dolor vitae.",
    contains_gift: false,
  },
  {
    _id: 53,
    name: "Dehumidifier",
    image: img_52,
    price: "$199.99",
    description:
      "Integer faucibus orci non urna efficitur tincidunt. Fusce tristique lectus turpis, vitae tincidunt erat lobortis a. Curabitur et justo pharetra, ullamcorper dolor vitae.",
    contains_gift: false,
  },
  {
    _id: 54,
    name: "Dehumidifier",
    image: img_53,
    price: "$199.99",
    description:
      "Integer faucibus orci non urna efficitur tincidunt. Fusce tristique lectus turpis, vitae tincidunt erat lobortis a. Curabitur et justo pharetra, ullamcorper dolor vitae.",
    contains_gift: false,
  },
  {
    _id: 55,
    name: "Dehumidifier",
    image: img_54,
    price: "$199.99",
    description:
      "Integer faucibus orci non urna efficitur tincidunt. Fusce tristique lectus turpis, vitae tincidunt erat lobortis a. Curabitur et justo pharetra, ullamcorper dolor vitae.",
    contains_gift: false,
  },
  {
    _id: 56,
    name: "Dehumidifier",
    image: img_55,
    price: "$199.99",
    description:
      "Integer faucibus orci non urna efficitur tincidunt. Fusce tristique lectus turpis, vitae tincidunt erat lobortis a. Curabitur et justo pharetra, ullamcorper dolor vitae.",
    contains_gift: false,
  },
  {
    _id: 57,
    name: "Dehumidifier",
    image: img_56,
    price: "$199.99",
    description:
      "Integer faucibus orci non urna efficitur tincidunt. Fusce tristique lectus turpis, vitae tincidunt erat lobortis a. Curabitur et justo pharetra, ullamcorper dolor vitae.",
    contains_gift: false,
  },
  {
    _id: 58,
    name: "Dehumidifier",
    image: img_57,
    price: "$199.99",
    description:
      "Integer faucibus orci non urna efficitur tincidunt. Fusce tristique lectus turpis, vitae tincidunt erat lobortis a. Curabitur et justo pharetra, ullamcorper dolor vitae.",
    contains_gift: false,
  },
  {
    _id: 59,
    name: "Dehumidifier",
    image: img_58,
    price: "$199.99",
    description:
      "Integer faucibus orci non urna efficitur tincidunt. Fusce tristique lectus turpis, vitae tincidunt erat lobortis a. Curabitur et justo pharetra, ullamcorper dolor vitae.",
    contains_gift: false,
  },
  {
    _id: 60,
    name: "Dehumidifier",
    image: img_59,
    price: "$199.99",
    description:
      "Integer faucibus orci non urna efficitur tincidunt. Fusce tristique lectus turpis, vitae tincidunt erat lobortis a. Curabitur et justo pharetra, ullamcorper dolor vitae.",
    contains_gift: false,
  },
  {
    _id: 61,
    name: "Iron",
    image: img_60,
    price: "$25.99",
    description:
      "Phasellus in urna et nisi varius volutpat. Cras euismod, lorem et interdum dignissim, lectus purus rutrum sapien, non sollicitudin est ligula eget enim. Aliquam tempor massa.",
    contains_gift: true,
  },
  {
    _id: 62,
    name: "Iron",
    image: img_61,
    price: "$25.99",
    description:
      "Phasellus in urna et nisi varius volutpat. Cras euismod, lorem et interdum dignissim, lectus purus rutrum sapien, non sollicitudin est ligula eget enim. Aliquam tempor massa.",
    contains_gift: true,
  },
  {
    _id: 63,
    name: "Iron",
    image: img_62,
    price: "$25.99",
    description:
      "Phasellus in urna et nisi varius volutpat. Cras euismod, lorem et interdum dignissim, lectus purus rutrum sapien, non sollicitudin est ligula eget enim. Aliquam tempor massa.",
    contains_gift: true,
  },
  {
    _id: 64,
    name: "Iron",
    image: img_63,
    price: "$25.99",
    description:
      "Phasellus in urna et nisi varius volutpat. Cras euismod, lorem et interdum dignissim, lectus purus rutrum sapien, non sollicitudin est ligula eget enim. Aliquam tempor massa.",
    contains_gift: true,
  },
  {
    _id: 65,
    name: "Iron",
    image: img_64,
    price: "$25.99",
    description:
      "Phasellus in urna et nisi varius volutpat. Cras euismod, lorem et interdum dignissim, lectus purus rutrum sapien, non sollicitudin est ligula eget enim. Aliquam tempor massa.",
    contains_gift: true,
  },
  {
    _id: 66,
    name: "Iron",
    image: img_65,
    price: "$25.99",
    description:
      "Phasellus in urna et nisi varius volutpat. Cras euismod, lorem et interdum dignissim, lectus purus rutrum sapien, non sollicitudin est ligula eget enim. Aliquam tempor massa.",
    contains_gift: true,
  },
  {
    _id: 67,
    name: "Iron",
    image: img_66,
    price: "$25.99",
    description:
      "Phasellus in urna et nisi varius volutpat. Cras euismod, lorem et interdum dignissim, lectus purus rutrum sapien, non sollicitudin est ligula eget enim. Aliquam tempor massa.",
    contains_gift: true,
  },
  {
    _id: 68,
    name: "Iron",
    image: img_67,
    price: "$25.99",
    description:
      "Phasellus in urna et nisi varius volutpat. Cras euismod, lorem et interdum dignissim, lectus purus rutrum sapien, non sollicitudin est ligula eget enim. Aliquam tempor massa.",
    contains_gift: true,
  },
  {
    _id: 69,
    name: "Iron",
    image: img_68,
    price: "$25.99",
    description:
      "Phasellus in urna et nisi varius volutpat. Cras euismod, lorem et interdum dignissim, lectus purus rutrum sapien, non sollicitudin est ligula eget enim. Aliquam tempor massa.",
    contains_gift: true,
  },
  {
    _id: 70,
    name: "Iron",
    image: img_69,
    price: "$25.99",
    description:
      "Phasellus in urna et nisi varius volutpat. Cras euismod, lorem et interdum dignissim, lectus purus rutrum sapien, non sollicitudin est ligula eget enim. Aliquam tempor massa.",
    contains_gift: true,
  },
  {
    _id: 71,
    name: "Iron",
    image: img_70,
    price: "$25.99",
    description:
      "Phasellus in urna et nisi varius volutpat. Cras euismod, lorem et interdum dignissim, lectus purus rutrum sapien, non sollicitudin est ligula eget enim. Aliquam tempor massa.",
    contains_gift: true,
  },
  {
    _id: 72,
    name: "Iron",
    image: img_71,
    price: "$25.99",
    description:
      "Phasellus in urna et nisi varius volutpat. Cras euismod, lorem et interdum dignissim, lectus purus rutrum sapien, non sollicitudin est ligula eget enim. Aliquam tempor massa.",
    contains_gift: true,
  },
  {
    _id: 73,
    name: "Iron",
    image: img_72,
    price: "$25.99",
    description:
      "Phasellus in urna et nisi varius volutpat. Cras euismod, lorem et interdum dignissim, lectus purus rutrum sapien, non sollicitudin est ligula eget enim. Aliquam tempor massa.",
    contains_gift: true,
  },
  {
    _id: 74,
    name: "Iron",
    image: img_73,
    price: "$25.99",
    description:
      "Phasellus in urna et nisi varius volutpat. Cras euismod, lorem et interdum dignissim, lectus purus rutrum sapien, non sollicitudin est ligula eget enim. Aliquam tempor massa.",
    contains_gift: true,
  },
  {
    _id: 75,
    name: "Iron",
    image: img_74,
    price: "$25.99",
    description:
      "Phasellus in urna et nisi varius volutpat. Cras euismod, lorem et interdum dignissim, lectus purus rutrum sapien, non sollicitudin est ligula eget enim. Aliquam tempor massa.",
    contains_gift: true,
  },
  {
    _id: 76,
    name: "Iron",
    image: img_75,
    price: "$25.99",
    description:
      "Phasellus in urna et nisi varius volutpat. Cras euismod, lorem et interdum dignissim, lectus purus rutrum sapien, non sollicitudin est ligula eget enim. Aliquam tempor massa.",
    contains_gift: true,
  },
  {
    _id: 77,
    name: "Iron",
    image: img_76,
    price: "$25.99",
    description:
      "Phasellus in urna et nisi varius volutpat. Cras euismod, lorem et interdum dignissim, lectus purus rutrum sapien, non sollicitudin est ligula eget enim. Aliquam tempor massa.",
    contains_gift: true,
  },
  {
    _id: 78,
    name: "Iron",
    image: img_77,
    price: "$25.99",
    description:
      "Phasellus in urna et nisi varius volutpat. Cras euismod, lorem et interdum dignissim, lectus purus rutrum sapien, non sollicitudin est ligula eget enim. Aliquam tempor massa.",
    contains_gift: true,
  },
  {
    _id: 79,
    name: "Iron",
    image: img_78,
    price: "$25.99",
    description:
      "Phasellus in urna et nisi varius volutpat. Cras euismod, lorem et interdum dignissim, lectus purus rutrum sapien, non sollicitudin est ligula eget enim. Aliquam tempor massa.",
    contains_gift: true,
  },
  {
    _id: 80,
    name: "Iron",
    image: img_79,
    price: "$25.99",
    description:
      "Phasellus in urna et nisi varius volutpat. Cras euismod, lorem et interdum dignissim, lectus purus rutrum sapien, non sollicitudin est ligula eget enim. Aliquam tempor massa.",
    contains_gift: true,
  },
  {
    _id: 81,
    name: "Hilnmket",
    image: img_80,
    price: "$50.99",
    description:
      "Phasellus in urna et nisi varius volutpat. Cras euismod, lorem et interdum dignissim, lectus purus rutrum sapien, non sollicitudin est ligula eget enim. Aliquam tempor massa.",
    contains_gift: false,
  },
  {
    _id: 82,
    name: "Hilnmket",
    image: img_81,
    price: "$50.99",
    description:
      "Phasellus in urna et nisi varius volutpat. Cras euismod, lorem et interdum dignissim, lectus purus rutrum sapien, non sollicitudin est ligula eget enim. Aliquam tempor massa.",
    contains_gift: false,
  },
  {
    _id: 83,
    name: "Hilnmket",
    image: img_82,
    price: "$50.99",
    description:
      "Phasellus in urna et nisi varius volutpat. Cras euismod, lorem et interdum dignissim, lectus purus rutrum sapien, non sollicitudin est ligula eget enim. Aliquam tempor massa.",
    contains_gift: false,
  },
  {
    _id: 84,
    name: "Hilnmket",
    image: img_83,
    price: "$50.99",
    description:
      "Phasellus in urna et nisi varius volutpat. Cras euismod, lorem et interdum dignissim, lectus purus rutrum sapien, non sollicitudin est ligula eget enim. Aliquam tempor massa.",
    contains_gift: false,
  },
  {
    _id: 85,
    name: "Hilnmket",
    image: img_84,
    price: "$50.99",
    description:
      "Phasellus in urna et nisi varius volutpat. Cras euismod, lorem et interdum dignissim, lectus purus rutrum sapien, non sollicitudin est ligula eget enim. Aliquam tempor massa.",
    contains_gift: false,
  },
  {
    _id: 86,
    name: "Hilnmket",
    image: img_85,
    price: "$50.99",
    description:
      "Phasellus in urna et nisi varius volutpat. Cras euismod, lorem et interdum dignissim, lectus purus rutrum sapien, non sollicitudin est ligula eget enim. Aliquam tempor massa.",
    contains_gift: false,
  },
  {
    _id: 87,
    name: "Hilnmket",
    image: img_86,
    price: "$50.99",
    description:
      "Phasellus in urna et nisi varius volutpat. Cras euismod, lorem et interdum dignissim, lectus purus rutrum sapien, non sollicitudin est ligula eget enim. Aliquam tempor massa.",
    contains_gift: false,
  },
  {
    _id: 88,
    name: "Hilnmket",
    image: img_87,
    price: "$50.99",
    description:
      "Phasellus in urna et nisi varius volutpat. Cras euismod, lorem et interdum dignissim, lectus purus rutrum sapien, non sollicitudin est ligula eget enim. Aliquam tempor massa.",
    contains_gift: false,
  },
  {
    _id: 89,
    name: "Hilnmket",
    image: img_88,
    price: "$50.99",
    description:
      "Phasellus in urna et nisi varius volutpat. Cras euismod, lorem et interdum dignissim, lectus purus rutrum sapien, non sollicitudin est ligula eget enim. Aliquam tempor massa.",
    contains_gift: false,
  },
  {
    _id: 90,
    name: "Hilnmket",
    image: img_89,
    price: "$50.99",
    description:
      "Phasellus in urna et nisi varius volutpat. Cras euismod, lorem et interdum dignissim, lectus purus rutrum sapien, non sollicitudin est ligula eget enim. Aliquam tempor massa.",
    contains_gift: false,
  },
  {
    _id: 91,
    name: "Hilnmket",
    image: img_90,
    price: "$50.99",
    description:
      "Phasellus in urna et nisi varius volutpat. Cras euismod, lorem et interdum dignissim, lectus purus rutrum sapien, non sollicitudin est ligula eget enim. Aliquam tempor massa.",
    contains_gift: false,
  },
  {
    _id: 92,
    name: "Hilnmket",
    image: img_91,
    price: "$50.99",
    description:
      "Phasellus in urna et nisi varius volutpat. Cras euismod, lorem et interdum dignissim, lectus purus rutrum sapien, non sollicitudin est ligula eget enim. Aliquam tempor massa.",
    contains_gift: false,
  },
  {
    _id: 93,
    name: "Hilnmket",
    image: img_92,
    price: "$50.99",
    description:
      "Phasellus in urna et nisi varius volutpat. Cras euismod, lorem et interdum dignissim, lectus purus rutrum sapien, non sollicitudin est ligula eget enim. Aliquam tempor massa.",
    contains_gift: false,
  },
  {
    _id: 94,
    name: "Hilnmket",
    image: img_93,
    price: "$50.99",
    description:
      "Phasellus in urna et nisi varius volutpat. Cras euismod, lorem et interdum dignissim, lectus purus rutrum sapien, non sollicitudin est ligula eget enim. Aliquam tempor massa.",
    contains_gift: false,
  },
  {
    _id: 95,
    name: "Hilnmket",
    image: img_94,
    price: "$50.99",
    description:
      "Phasellus in urna et nisi varius volutpat. Cras euismod, lorem et interdum dignissim, lectus purus rutrum sapien, non sollicitudin est ligula eget enim. Aliquam tempor massa.",
    contains_gift: false,
  },
  {
    _id: 96,
    name: "Hilnmket",
    image: img_95,
    price: "$50.99",
    description:
      "Phasellus in urna et nisi varius volutpat. Cras euismod, lorem et interdum dignissim, lectus purus rutrum sapien, non sollicitudin est ligula eget enim. Aliquam tempor massa.",
    contains_gift: false,
  },
  {
    _id: 97,
    name: "Hilnmket",
    image: img_96,
    price: "$50.99",
    description:
      "Phasellus in urna et nisi varius volutpat. Cras euismod, lorem et interdum dignissim, lectus purus rutrum sapien, non sollicitudin est ligula eget enim. Aliquam tempor massa.",
    contains_gift: false,
  },
  {
    _id: 98,
    name: "Hilnmket",
    image: img_97,
    price: "$50.99",
    description:
      "Phasellus in urna et nisi varius volutpat. Cras euismod, lorem et interdum dignissim, lectus purus rutrum sapien, non sollicitudin est ligula eget enim. Aliquam tempor massa.",
    contains_gift: false,
  },
  {
    _id: 99,
    name: "Hilnmket",
    image: img_98,
    price: "$50.99",
    description:
      "Phasellus in urna et nisi varius volutpat. Cras euismod, lorem et interdum dignissim, lectus purus rutrum sapien, non sollicitudin est ligula eget enim. Aliquam tempor massa.",
    contains_gift: false,
  },
  {
    _id: 100,
    name: "Hilnmket",
    image: img_99,
    price: "$50.99",
    description:
      "Phasellus in urna et nisi varius volutpat. Cras euismod, lorem et interdum dignissim, lectus purus rutrum sapien, non sollicitudin est ligula eget enim. Aliquam tempor massa.",
    contains_gift: false,
  },
  {
    _id: 101,
    name: "Hilnmket",
    image: img_100,
    price: "$50.99",
    description:
      "Phasellus in urna et nisi varius volutpat. Cras euismod, lorem et interdum dignissim, lectus purus rutrum sapien, non sollicitudin est ligula eget enim. Aliquam tempor massa.",
    contains_gift: false,
  },
  {
    _id: 102,
    name: "Bitrush",
    image: img_101,
    price: "$50.99",
    description:
      "Phasellus in urna et nisi varius volutpat. Cras euismod, lorem et interdum dignissim, lectus purus rutrum sapien, non sollicitudin est ligula eget enim. Aliquam tempor massa.",
    contains_gift: true,
  },
  {
    _id: 103,
    name: "Bitrush",
    image: img_102,
    price: "$50.99",
    description:
      "Phasellus in urna et nisi varius volutpat. Cras euismod, lorem et interdum dignissim, lectus purus rutrum sapien, non sollicitudin est ligula eget enim. Aliquam tempor massa.",
    contains_gift: true,
  },
  {
    _id: 104,
    name: "Bitrush",
    image: img_103,
    price: "$50.99",
    description:
      "Phasellus in urna et nisi varius volutpat. Cras euismod, lorem et interdum dignissim, lectus purus rutrum sapien, non sollicitudin est ligula eget enim. Aliquam tempor massa.",
    contains_gift: true,
  },
  {
    _id: 105,
    name: "Bitrush",
    image: img_104,
    price: "$50.99",
    description:
      "Phasellus in urna et nisi varius volutpat. Cras euismod, lorem et interdum dignissim, lectus purus rutrum sapien, non sollicitudin est ligula eget enim. Aliquam tempor massa.",
    contains_gift: true,
  },
  {
    _id: 106,
    name: "Bitrush",
    image: img_105,
    price: "$50.99",
    description:
      "Phasellus in urna et nisi varius volutpat. Cras euismod, lorem et interdum dignissim, lectus purus rutrum sapien, non sollicitudin est ligula eget enim. Aliquam tempor massa.",
    contains_gift: true,
  },
  {
    _id: 107,
    name: "Bitrush",
    image: img_106,
    price: "$50.99",
    description:
      "Phasellus in urna et nisi varius volutpat. Cras euismod, lorem et interdum dignissim, lectus purus rutrum sapien, non sollicitudin est ligula eget enim. Aliquam tempor massa.",
    contains_gift: true,
  },
  {
    _id: 108,
    name: "Bitrush",
    image: img_107,
    price: "$50.99",
    description:
      "Phasellus in urna et nisi varius volutpat. Cras euismod, lorem et interdum dignissim, lectus purus rutrum sapien, non sollicitudin est ligula eget enim. Aliquam tempor massa.",
    contains_gift: true,
  },
  {
    _id: 109,
    name: "Bitrush",
    image: img_108,
    price: "$50.99",
    description:
      "Phasellus in urna et nisi varius volutpat. Cras euismod, lorem et interdum dignissim, lectus purus rutrum sapien, non sollicitudin est ligula eget enim. Aliquam tempor massa.",
    contains_gift: true,
  },
  {
    _id: 110,
    name: "Bitrush",
    image: img_109,
    price: "$50.99",
    description:
      "Phasellus in urna et nisi varius volutpat. Cras euismod, lorem et interdum dignissim, lectus purus rutrum sapien, non sollicitudin est ligula eget enim. Aliquam tempor massa.",
    contains_gift: true,
  },
  {
    _id: 111,
    name: "Bitrush",
    image: img_110,
    price: "$50.99",
    description:
      "Phasellus in urna et nisi varius volutpat. Cras euismod, lorem et interdum dignissim, lectus purus rutrum sapien, non sollicitudin est ligula eget enim. Aliquam tempor massa.",
    contains_gift: true,
  },
];

export const baner = {
  beauty,
  bookstore,
  gamingstore,
  kitchen_favorite,
  toys,
};
